import { ReactNode } from 'react'
import { DashboardContainer } from '@forwardflow/components/Dashboard'

/** The page frame: the dashboard's header and side nav around the flow. */
export const FlowShell = ({
   children,
   className = '',
}: {
   children: ReactNode
   className?: string
}) => <DashboardContainer className={className}>{children}</DashboardContainer>
